import client from "api/client";


const _client = client.route("/error");

const event = {
	log: (payload) => _client.post("", payload)
};

export default event;